{
  "list": {
    "title": "المصروفات",
    "subtitle": "{{n}} مصروفاً · الإجمالي {{total}}",
    "exportCsv": "تصدير CSV",
    "new": "مصروف جديد",
    "caption": "قائمة المصروفات",
    "emptyTitle": "لا توجد مصروفات",
    "emptyFiltered": "لا توجد نتائج مطابقة.",
    "emptyHint": "سجّل أول مصروف."
  },
  "filters": {
    "searchLabel": "بحث في الوصف",
    "searchPlaceholder": "ابحث في الوصف",
    "type": "النوع",
    "allTypes": "كل الأنواع",
    "period": "الفترة",
    "allPeriods": "كل الفترات",
    "thisMonth": "هذا الشهر",
    "lastMonth": "الشهر الماضي",
    "custom": "فترة مخصصة",
    "from": "من",
    "to": "إلى"
  },
  "columns": {
    "date": "التاريخ",
    "type": "النوع",
    "description": "الوصف",
    "amount": "المبلغ",
    "receipt": "الإيصال",
    "createdBy": "أضافه"
  },
  "row": {
    "viewReceipt": "عرض إيصال {{name}}",
    "view": "عرض",
    "edit": "تعديل المصروف",
    "delete": "حذف المصروف",
    "deleteTitle": "حذف المصروف",
    "deleteDescription": "سيُحذف مصروف {{type}} بمبلغ {{amount}} بتاريخ {{date}} ويُستبعد من الإجماليات.",
    "deleteConfirm": "حذف",
    "deleted": "تم حذف المصروف"
  },
  "dialog": {
    "newTitle": "مصروف جديد",
    "editTitle": "تعديل المصروف",
    "description": "المصروفات تُخصم من صافي الرسوم لحساب صافي الربح.",
    "receiptTitle": "إيصال المصروف"
  },
  "form": {
    "date": "التاريخ",
    "amount": "المبلغ ({{currency}})",
    "type": "نوع المصروف",
    "typePlaceholder": "اختر النوع",
    "inactiveOption": "{{name}} (موقوف)",
    "description": "الوصف",
    "optional": "اختياري",
    "receipt": "الإيصال",
    "removeReceipt": "إزالة",
    "saving": "جاري الحفظ…",
    "saveChanges": "حفظ التعديلات",
    "submit": "تسجيل المصروف",
    "saved": "تم حفظ التعديلات",
    "created": "تم تسجيل المصروف",
    "typeInactive": "هذا النوع موقوف، اختر نوعاً آخر",
    "saveFailed": "تعذر الحفظ"
  },
  "validation": {
    "dateRequired": "التاريخ مطلوب",
    "dateFuture": "لا يمكن أن يكون التاريخ في المستقبل",
    "typeRequired": "اختر نوع المصروف",
    "amountPositive": "أدخل مبلغاً أكبر من صفر",
    "descriptionMax": "الحد الأقصى 500 حرف"
  }
}
